import { PluginSpecification } from '@valtimo/plugin';
import { TEZZA_PLUGIN_LOGO_BASE64 } from './assets/index';
import { ExecuteActionConfigurationComponent } from './components/execute-action/execute-action-configuration.component';
import { TezzaConfigurationComponent } from './components/tezza-configuration/tezza-configuration.component';

const tezzaPluginSpecification: PluginSpecification = {
    /* 
    The plugin definition key of the plugin. 
    This needs to be the same as the id received from the back-end
     */
    pluginId: 'tezzaplugin',
    pluginConfigurationComponent: TezzaConfigurationComponent,
    pluginLogoBase64: TEZZA_PLUGIN_LOGO_BASE64,
    functionConfigurationComponents: {
        'execute-action': ExecuteActionConfigurationComponent
    },
    pluginTranslations: {
        nl: {
            title: 'Tezza plug-in',
            description: 'Beheert de instellingen voor de connectie met Tezza & Alfresco',
            configurationTitle: 'Configuratienaam',
            alfrescoBaseUrl: 'Alfresco basis URL',
            username: 'Alfresco gebruikersnaam',
            password: 'Alfresco wachtwoord',
            tezzaAppBaseUrl: 'Tezza basis URL',
            tezzaRmBaseUrl: 'Tezza RM basis URL',
            emailFrom: 'Email afzender gzac',
            defaultDossiers: 'Standaard dossiers',
            defaultDossiersTooltip: 'Dit selecteerd het standaard dossiers die moeten laden, als er geen andere specificaties zijn',
            'execute-action': "Actie Executor",
            executeActionInformation: 'Dit voert een Action Executor call uit bij Alfresco',
            actionDefinitionId: 'Actie definitie',
            actionDefinitionIdTooltip: 'Selecteer de gewenste actie',
            targetId: 'TargetId',
            targetIdTooltip: 'Geef optioneel een nodeId als doel op voor de actie',
            actionParameters: 'Actie parameters',
            actionParametersTooltip: 'geef de actie parameters mee, in JSON. Vervang alle : voor ;. Karakter ; is voor dit veld verder een verboden karakter'
        },
        en: {
            title: 'Tezza plug-in',
            description: 'Controls the settings for the connection with Tezza & Alfresco',
            configurationTitle: 'Configurationname',
            alfrescoBaseUrl: 'Alfresco base URL',
            username: 'Alfresco username',
            password: 'Alfresco password',
            tezzaAppBaseUrl: 'Tezza base URL',
            tezzaRmBaseUrl: 'Tezza RM base URL',
            emailFrom: 'Email sender gzac',
            defaultDossiers: 'default cases',
            defaultDossiersTooltip: 'This selects the default cases that should be loaded, if no others are specified',
            'execute-action': "Actie Executor",
            executeActionInformation: 'Dit voert een Action Executor call uit bij Alfresco',
            actionDefinitionId: 'Actie definitie',
            actionDefinitionIdTooltip: 'Selecteer de gewenste actie',
            targetId: 'TargetId',
            targetIdTooltip: 'Geef optioneel een nodeId als doel op voor de actie',
            actionParameters: 'Actie parameters',
            actionParametersTooltip: 'geef de actie parameters mee, in JSON. Replace all : with ;. Character ; is apart from the substitution a forbiddden character.'
        },
        de: {
            title: 'Tezza plug-in',
            description: 'Beheert de instellingen voor de connectie met Tezza & Alfresco',
            'print-message': 'Print bericht',
            configurationTitle: 'Configuratienaam',
            alfrescoBaseUrl: 'Alfresco basis URL',
            username: 'Alfresco gebruikersnaam',
            password: 'Alfresco wachtwoord',
            tezzaAppBaseUrl: 'Tezza basis URL',
            tezzaRmBaseUrl: 'Tezza RM basis URL',
            emailFrom: 'Email afzender gzac',
            defaultDossiers: 'Standaard dossiers',
            defaultDossiersTooltip: 'Dit selecteerd het standaard dossiers die moeten laden, als er geen andere specificaties zijn',
            'execute-action': "Actie Executor",
            executeActionInformation: 'Dit voert een Action Executor call uit bij Alfresco',
            actionDefinitionId: 'Actie definitie',
            actionDefinitionIdTooltip: 'Selecteer de gewenste actie',
            targetId: 'TargetId',
            targetIdTooltip: 'Geef optioneel een nodeId als doel op voor de actie',
            actionParameters: 'Actie parameters',
            actionParametersTooltip: 'geef de actie parameters mee, in JSON. Vervang alle : voor ;. Karakter ; is voor dit veld verder een verboden karakter'
        },
    },
};

export { tezzaPluginSpecification };
